jQuery3_4_1(document).ready(function($){
    class Togglebutton {
        constructor(parent) {
            const self = this;
            if(parent.togglebutton){
                return;
            }
            parent.togglebutton = this;
            self.parent = $(parent);
            self.awake();
            setTimeout(function(){
                self.start();
            },0);
        }

        awake(){
            const self = this;
            self.emitter = new DDEmitter();
            self.visualSelector = self.parent.find(".dd-togglebutton-selector");
            self.index = self.parent.data("start-index");
            self.registerButtons();
            self.registerEvents();
            self.moveSelectorToIndex(self.index, undefined, false);
            // // self.inUse = false;
            // setTimeout(function(){
            //     // if(self.inUse){
            //     //     return;
            //     // }
            //     self.moveSelectorToIndex(self.index, undefined, false);
            // }, 1000);
        }

        start(){
            const self = this;
            self.visualSelector.css("transition", "all var(--dd-animation-time) var(--dd-animation-easing)");
        }

        registerButtons(){
            const self = this;
            self.buttons = self.parent.find(".dd-togglebutton-choice");
            self.buttons.on("click", function(event){
                self.handleButtonClick(event);
            });
        }

        registerEvents(){
            const self = this;
            $(window).on("resize", function() {
                self.moveSelectorToIndex(self.index, undefined, false);
            });
            $(".dd-button-up-one-level").on("click", function(event){
                setTimeout(function(){
                    self.moveSelectorToIndex(self.index, undefined, false);
                }, 0);
            });
        }

        registerHistoryEvents(){
            const self = this;
            DDPlatform.history.on("pop", function(event){
                const targetStateData = event.targetState;
                const toggleChoice = targetStateData["toggle"];
                const doPush = false;
                self.moveSelectorToValue(toggleChoice, doPush);
            });
        }

        handleButtonClick(event){
            const self = this;
            // self.inUse = true;
            const button = $(event.currentTarget);
            const index = button.data("index");
            self.moveSelectorToIndex(index, event);
        }

        moveSelector(position, width){
            const self = this;
            self.visualSelector.css("left", position+"px").css("width", width+"px")
        }

        moveSelectorToIndex(index, event = undefined, setUrl = true){
            const self = this;
            const button = self.buttons.eq(index);
            const choice = button.data("choice");
            self.buttons.removeClass("dd-selected");
            button.addClass("dd-selected");
            const padding = 3;
            const width = button.outerWidth() + 2 * padding;
            const position = button.position().left - padding; // - (button.width() / 2);
            self.moveSelector(position, width);
            self.index = index;
            if(setUrl){
                DDPlatform.history.push({"toggle":choice});
            }
            self.emitter.emit("change", event, choice, index);
        }

        moveSelectorToValue(value, setUrl = true){
            const self = this;
            const index = self.getIndexFromValue(value);
            self.moveSelectorToIndex(index, undefined, setUrl);
        }

        getIndexFromValue(value){
            const self = this;
            const element = self.parent.find(".dd-togglebutton-choice[data-choice='"+value+"']");
            const index = element.data("index");
            return index;
        }


        // EMITTER
        on(eventName, callback) {  // Available events: change
            const self = this;
            self.emitter.on(eventName, callback);
        }

        off(eventName, callback) {
            const self = this;
            self.emitter.off(eventName, callback);
        }
    }

    class DDEmitter {
        constructor(){
            this.events = {};
        }
    
        on(eventName, callback) {
            const self = this;
            if (!self.events[eventName]) {
                self.events[eventName] = [];
            }
            self.events[eventName].push(callback);
        }
    
        off(eventName, callback) {
            const self = this;
            const eventHandlers = self.events[eventName];
            if (eventHandlers) {
                self.events[eventName] = eventHandlers.filter(fn => fn !== callback);
            }
        }
    
        emit(eventName, ...args) {
            const self = this;
            const eventHandlers = self.events[eventName];
            if (eventHandlers) {
                eventHandlers.forEach(callback => {
                    callback(...args);
                });
            }
        }
    }

    registerOnLoadEvent(function(){
        $(".dd-togglebutton").each(function(){
            new Togglebutton(this);
        })
    });

});
  